export default __webpack_public_path__ + "c35c3a4f780aa8162c99700bd7c5c411.png";